import { Flex } from "@chakra-ui/react";
import BackgroundImageBanner from "../../components/molecules/BackgroundImageBanner";
import InformativeCardContainer from "../../components/organisms/InformativeCardContainer";
import MainHeader from "../../components/organisms/MainHeader";
import PersonalizedService from "../../components/organisms/PersonalizedService";
import { guaranteeCardContent } from "../../constants/guaranteeCardContent";
import { serviceCardContent } from "../../constants/serviceCardContent";

const MainHeaderContent = {
  title: "Gastos Comunes Eficientes, Administración Transparente",
};
const HomeScreen = () => {
  return (
    <Flex flexDirection={"column"}>
      <MainHeader
        withButton
        classNameProp={"home-hero-section"}
        title={MainHeaderContent.title}
      />
      <PersonalizedService />
      <InformativeCardContainer
        headingText={"Nuestros Servicios"}
        cardContent={serviceCardContent}
        maxWith="1447px"
        withIcon
      />
      <BackgroundImageBanner
        title={"¿Cómo diagnosticamos?"}
        text={
          "Diagnóstico Completo para tu Comunidad:\nIdentificamos Problemas, Proponemos Soluciones y Aseguramos el Cumplimiento Legal"
        }
        buttonText={"Contáctanos"}
        to={"https://forms.gle/ynBerfiVpTfy9HrQ8"}
      />
      <InformativeCardContainer
        headingText={"Garantizamos nuestra gestión"}
        cardContent={guaranteeCardContent}
        maxWith="1448px"
        withIcon
        withButton
      />
    </Flex>
  );
};

export default HomeScreen;
